import React, { FC, useState, useEffect, useRef, ChangeEvent } from 'react';

export interface ResizableTextAreaProps {
  value: string;
  name: string;
  onChange: (value: string) => void;
  maxHeight: number;
  classes?: string;
  props?: any;
}

const ResizableTextArea: FC<ResizableTextAreaProps> = ({ value, name, onChange, classes, maxHeight, props }) => {
  const textAreaRef = useRef<HTMLTextAreaElement>(null);
  const parentRef = useRef<HTMLDivElement>(null);

  const [textAreaHeight, setTextAreaHeight] = useState<string>('auto');
  const [clientHeight, setClientHeight] = useState<number>(0);
  const [maxWidth, setMaxWidth] = useState<number>(0);

  const onChangeHandler = (event: ChangeEvent<HTMLTextAreaElement>) => {
    const value = event.target.value.toUpperCase();
    onChange(value);
  };

  useEffect(() => {
    setTextAreaHeight(`${textAreaRef.current!.scrollHeight}px`);
    setClientHeight(textAreaRef.current!.clientHeight);
    textAreaRef.current!.scrollIntoView();
  }, [textAreaHeight, clientHeight, textAreaRef, value]);

  useEffect(() => {
    if (parentRef.current) setMaxWidth(parentRef.current.clientWidth);
  }, [parentRef]);

  return (
    <div ref={parentRef} className="h-px-30">
      <textarea
        value={value}
        name={name}
        className={
          classes ||
          'h-auto min-h-12 min-w-min bg-white h-12 p-4 font-normal leading-none border rounded-lg appearance-none font-effra text-black-default border-gray-default focus:outline-none active:outline-none'
        }
        ref={textAreaRef}
        rows={1}
        cols={value.length ? value.length + 5 : 6}
        style={{
          maxWidth: `${maxWidth}px`,
          height: textAreaHeight,
          maxHeight: `${maxHeight}rem`,
          overflow: clientHeight > maxHeight * 16 - 10 ? 'auto' : 'hidden'
        }}
        onChange={(event) => onChangeHandler(event)}
        {...props}
      />
    </div>
  );
};

export default ResizableTextArea;
